import {
  SELLERCHATLIST_FETCHITEMS_LOAD,
  SELLERCHATLIST_FETCHITEMS_SUCCEED,
  SELLERCHATLIST_FETCHITEMS_FAIL,
  SELLERCHATLIST_CHANGETABLE_CHANGE,
  SELLERCHATLIST_SEARCHTABLE_EDIT,
  SELLERCHATLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERCHATLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case SELLERCHATLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case SELLERCHATLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case SELLERCHATLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case SELLERCHATLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case SELLERCHATLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerChatList.js